import { render, staticRenderFns } from "./LeaveBalanceView.vue?vue&type=template&id=a4b646c0&"
import script from "./LeaveBalanceView.vue?vue&type=script&lang=js&"
export * from "./LeaveBalanceView.vue?vue&type=script&lang=js&"
import style0 from "./LeaveBalanceView.vue?vue&type=style&index=0&id=a4b646c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports